export var masterFirebaseConfig = {
  apiKey: "AIzaSyD7d_JwsK36Cfy8sIvYEDTIb9UEeVhtKko",
  authDomain: "quasi-etsy.firebaseapp.com",
  databaseURL: "https://quasi-etsy.firebaseio.com",
  projectId: "quasi-etsy",
  storageBucket: "quasi-etsy.appspot.com",
  messagingSenderId: "543971348341"

  };



// WEBPACK FOOTER //
// C:/Users/sara/epicodus/quasi-etsy/src/app/api-keys.ts